/* eslint-disable multiline-ternary */
// import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  Label,
  Row,
} from 'reactstrap'
import Select from 'react-select'
// import { EmailAuthSchemaValidations } from '../validations'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateEmailConfig } from '../../../invoice-issuance/store'
import { authorizeAccess, editAction, revokeAccess } from '../../store'

const providersOptions = [
  {
    label: 'Google',
    value: 'GOOGLE',
  },
  {
    label: 'Microsoft',
    value: 'MICROSOFT',
  },
]
const typeOptions = [
  {
    label: 'Corporativo',
    value: 'CORPORATE',
  },
  {
    label: 'Personal',
    value: 'PERSONAL',
  },
]

export function EmailAuthForm() {
  const [isEdited, setisEdited] = useState(false)
  const { data } = useSelector((state) => state.businessManager)
  const { emailConfig } = useSelector((state) => state.invoiceIssuance)
  const dispatch = useDispatch()

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      emailProvider: null,
      accountType: null,
    },
    // mode: 'all',
    // reValidateMode: 'onChange',
    // resolver: yupResolver(EmailAuthSchemaValidations),
  })

  useEffect(() => {
    if (emailConfig.emailProvider === null) {
      setValue('emailProvider', emailConfig.emailProvider)
    }

    if (emailConfig.accountType === null) {
      setValue('accountType', emailConfig.accountType)
    }
  }, [emailConfig.emailProvider, emailConfig.accountType])

  const handleEdit = (event) => {
    event.preventDefault()
    setisEdited(!isEdited)
  }

  const onSubmit = () => {
    const newData = {
      ...data,
      accountType: emailConfig.accountType,
      emailProvider: emailConfig.emailProvider,
    }
    dispatch(editAction({ ...data, ...newData }, true))
    setisEdited(false)
  }

  const handleAuthAccess = async () => {
    try {
      const response = await authorizeAccess(emailConfig.emailProvider)

      if (
        response.success &&
        typeof response.authUrl === 'string' &&
        response.authUrl?.trim().length > 0
      ) {
        window.location.href = response.authUrl
      }
    } catch (error) {
      //
    }
  }

  const handleRevokeAuthAccess = async () => {
    try {
      const response = await revokeAccess(emailConfig.emailProvider)

      if (response.success) {
        dispatch(
          updateEmailConfig({
            authorized: false,
          })
        )
      }
    } catch (error) {
      //
    }
  }

  if (!emailConfig.isActive) {
    return null
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Card>
        <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
          <CardTitle tag="h4">
            Configuración de recepción de correo
          </CardTitle>
        </CardHeader>
        <Row
          className="mx-0"
          style={{ paddingTop: '2%', paddingLeft: '5%' }}
        >
          <Col
            md="6"
            sm="12"
          >
            <Label className="me-1">Proveedor</Label>
            <Controller
              name="emailProvider"
              control={control}
              render={({ field }) => (
                <>
                  <Select
                    {...field}
                    options={providersOptions}
                    isDisabled={!isEdited}
                    value={providersOptions.find(
                      (item) => item.value === emailConfig.emailProvider
                    )}
                    onChange={(item) => {
                      dispatch(
                        updateEmailConfig({
                          emailProvider: item.value,
                        })
                      )
                      setValue('emailProvider', item.value)
                    }}
                  />
                  {errors.emailProvider && (
                    <FormFeedback className="d-block">
                      {errors.emailProvider.message}
                    </FormFeedback>
                  )}
                </>
              )}
            />
          </Col>
          <Col
            md="6"
            sm="12"
          >
            <Label className="me-1">Tipo</Label>
            <Controller
              name="accountType"
              control={control}
              render={({ field }) => (
                <>
                  <Select
                    {...field}
                    options={typeOptions}
                    isDisabled={!isEdited}
                    value={typeOptions.find(
                      (item) => item.value === emailConfig.accountType
                    )}
                    onChange={(item) => {
                      dispatch(
                        updateEmailConfig({
                          accountType: item.value,
                        })
                      )
                      setValue('accountType', item.value)
                    }}
                  />
                  {errors.accountType && (
                    <FormFeedback className="d-block">
                      {errors.accountType.message}
                    </FormFeedback>
                  )}
                </>
              )}
            />
          </Col>
        </Row>
        <Row
          className="mx-0"
          style={{ paddingTop: '2%', paddingLeft: '5%' }}
        >
          <Col className="d-flex align-items-center gap-2 justify-content-sm-center mx-2 mb-3 mt-1">
            {emailConfig.authorized ? (
              <Button
                style={{
                  size: '10px',
                  width: '200px',
                  marginTop: '10px',
                }}
                color="primary"
                onClick={handleRevokeAuthAccess}
              >
                Revocar Acceso
              </Button>
            ) : (
              <Button
                style={{
                  size: '10px',
                  width: '200px',
                  marginTop: '10px',
                }}
                color="primary"
                onClick={handleAuthAccess}
              >
                Autorizar Acceso
              </Button>
            )}

            {isEdited ? (
              <Button
                style={{
                  size: '10px',
                  width: '200px',
                  marginTop: '10px',
                }}
                color="primary"
                type="submit"
              >
                Guardar
              </Button>
            ) : (
              <Button
                style={{
                  size: '10px',
                  width: '200px',
                  marginTop: '10px',
                }}
                color="primary"
                onClick={handleEdit}
              >
                Editar
              </Button>
            )}
          </Col>
        </Row>
      </Card>
    </Form>
  )
}
